import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { NewsletterEndpoint } from '../constants/newsletter-endpoint';
import { NewsletterItem } from '../models/newsletter.model';
import { NewsletterType } from '../models/newsletter-type.model';

@Injectable({
  providedIn: 'root',
})
export class NewsletterItemService {
  constructor(private http: WrapperHttpService) {}

  getNewsletterItem(newsletterItemId: number): Observable<NewsletterItem> {
    return this.http.withLoading().get<NewsletterItem>(`${API_URL}${NewsletterEndpoint.Base}/${newsletterItemId}`);
  }

  getNewsletterTypes(): Observable<NewsletterType[]> {
    return this.http
      .withLoading()
      .get<NewsletterType[]>(`${API_URL}${NewsletterEndpoint.Base}${NewsletterEndpoint.Type}`);
  }

  saveNewsletterItem(body: Partial<NewsletterItem>): Observable<void> {
    return this.http.withLoading().post<void>(`${API_URL}${NewsletterEndpoint.Base}`, body);
  }

  sendNewsletterItem(newsletterItemId: number): Observable<void> {
    return this.http
      .withLoading()
      .post<void>(`${API_URL}${NewsletterEndpoint.Base}/${newsletterItemId}${NewsletterEndpoint.Send}`, {});
  }
}
